import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { InvoiceUnchargedTransaction } from "../../../components/Reports/InvoiceUnchargedTransaction";

export interface IInvoiceUnchargedTransactionPage {}

export const InvoiceUnchargedTransactionPage: FC<IInvoiceUnchargedTransactionPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Invoice Uncharged Transactions"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<InvoiceUnchargedTransaction />}
    />
  );
};
